import React from "react";
import moment from "moment";
import classnames from "classnames";
import { colorClassForJobSpent, statusTextForJobSpent } from "utils/jobStatus";
import { Link } from "react-router-dom";
import { MINUTE_DECIMAL_PLACES } from "constants/util";

interface Props {
    job: sage.model.IJob;
}

const BalanceMinutesSpentBodyPageJobRow: React.FC<Props> = ({ job }) => {
    const createdAt = moment(new Date(job.created_at)).fromNow();

    return (
        <Link
            role="tab"
            to={`/home/dashboard/jobs/${job.id}`}
            className="list-group-item list-group-item-action"
        >
            <div className="d-flex align-items-center justify-content-between">
                <h5 className="mb-1">{job.name || "Unnamed Job"}</h5>
                <span
                    className={classnames(
                        "badge badge-pill",
                        `badge-${colorClassForJobSpent(job)}`
                    )}
                >
                    {statusTextForJobSpent(job)}
                </span>
            </div>
            {job.total_counted_time == null ? (
                <p className="mb-1">Still pending. No cost yet</p>
            ) : (
                <p className="mb-1">
                    Deducted{" "}
                    {job.total_counted_time.toFixed(MINUTE_DECIMAL_PLACES)}{" "}
                    minutes from your account for this job.
                </p>
            )}
            <small>Created {createdAt}</small>
        </Link>
    );
};

export default BalanceMinutesSpentBodyPageJobRow;
